import { type IOrder } from "@/interfaces/api/order.interface"
import { BaseModel } from "@/models/base.model"
import { Message } from "@/models/message.model"
import { Instruction } from "@/models/instruction.model"
import type { Project } from "@/models/project.model"
import { type Moment } from "moment"
import { ModelFactory } from "@/factories/model-factory"

export class Order extends BaseModel implements IOrder {
  public static className = "Order" // Used for socket communication.
  public static verboseName = "order"

  id: string

  instructions: Instruction[]

  messages: Message[]

  reference: string

  isPrepared: boolean

  isMultiSelected: boolean

  localUpdatedAt?: Moment

  constructor(order: IOrder, managed = false) {
    super(order)
    this.id = order.id
    this.instructions = ModelFactory.childModels(Instruction, order.instructions, managed)
    this.messages = ModelFactory.childModels(Message, order.messages, managed)

    this.reference = order.reference
    this.isPrepared = order.isPrepared
    this.isMultiSelected = order.isMultiSelected

    this.localUpdatedAt = this.updatedAt
  }

  public getMostRecentProject(): Project | null {
    const instructionsWithProject = this.instructions.filter((val: Instruction) => val.project)
    if (instructionsWithProject.length > 0) {
      return instructionsWithProject[instructionsWithProject.length - 1].project!
    }
    return null
  }

  public concatenateMessages(): string {
    return this.messages.map((message) => message.body).join("\n")
  }

  // public hasPresentOrFutureInstructions(): boolean {
  //   const startOfToday = moment().startOf("day")
  //   return this.instructions.some((instruction) => instruction.timeStart >= startOfToday)
  // }
}
